// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const mediaGalleryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMediaImages: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/car-image/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
    }),
    uploadMediaImage: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/car-image",
        method: "POST",
        body: data,
      }),
    }),

    deleteMediaImage: builder.mutation({
      query: ({ id }) => ({
        url: `/api/v1/admin/car-image/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetMediaImagesQuery,
  useUploadMediaImageMutation,
  useDeleteMediaImageMutation,
} = mediaGalleryApiSlice;
